import React, { useRef, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MuiAlert from '@material-ui/lab/Alert'
import { Snackbar } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
  yellow: {
    backgroundColor: '#FFD800',
  },
  green: {
    backgroundColor: '#7ACF38',
  },
  round: {
    borderRadius: '10px',
  }
}))

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}
export default function DisplayMessage(props) {
  const classes = useStyles()
  const outerRef = useRef()

  const handleOuterClick = (e) => {
    if (!outerRef.current?.contains(e.target)) {
      props.handleClose()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOuterClick)

    return () => {
      document.removeEventListener('mousedown', handleOuterClick)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={classes.root} ref={outerRef}>
      <Snackbar open={props.open} autoHideDuration={6000} onClose={props.handleClose}>
        <Alert onClose={props.handleClose} severity={props.messageType}>
          {props.message}
        </Alert>
      </Snackbar>
    </div>
  )
}